// extracted by mini-css-extract-plugin
export default {"IssuuPreview__dialog__iframe":"ev0YmISsje4ES0u3xabf","IssuuPreview__button":"HNqsn14_a8Mp9lxR_0xH"};